import { Controller } from '@hotwired/stimulus';
import { loadFlag, saveFlag } from '../storage_flag';

export default class extends Controller {
  static targets = ['sidebar', 'opener'];

  static values = { storageKey: String };

  connect() {
    this.apply(loadFlag(this.storageKeyValue));
  }

  toggle() {
    const next = !this.sidebarTarget.classList.contains('d-none');
    this.apply(next);
    saveFlag(this.storageKeyValue, next);
  }

  apply(collapsed) {
    this.sidebarTarget.classList.toggle('d-none', collapsed);
    if (this.hasOpenerTarget) {
      this.openerTarget.classList.toggle('d-none', !collapsed);
    }
  }
}
